import { useEffect } from 'react';

import { hideLoader } from '../utils/hideLoader';

export function useHideLoader() {
  useEffect(() => {
    hideLoader();
  }, []);
}
